import firebase from 'firebase'
import * as firebaseui from 'firebaseui'
import 'firebaseui/dist/firebaseui.css'
import store from '@/store'
import uuid from 'uuid'

const config = {
	apiKey: 'AIzaSyCSo7uDsDbaQ9q-lO46I3fZrDjOLVTfGLY',
	authDomain: 'sexytodo-61d0c.firebaseapp.com',
	databaseURL: 'https://sexytodo-61d0c.firebaseio.com',
	projectId: 'sexytodo-61d0c',
	storageBucket: 'sexytodo-61d0c.appspot.com',
	messagingSenderId: '773253342676',
	appId: '1:773253342676:web:2f57c0471b7dc63b',
}

// const uiConfig = {
// 	signInSuccessUrl: 'http://localhost:8080#success',
// 	signInOptions: [
// 		// Leave the lines as is for the providers you want to offer your users.
// 		{
// 			provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
// 			requireDisplayName: false,
// 		},
// 		firebase.auth.GoogleAuthProvider.PROVIDER_ID,
// 		firebase.auth.FacebookAuthProvider.PROVIDER_ID,
// 		firebase.auth.TwitterAuthProvider.PROVIDER_ID,
// 		firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID,

// 		// firebase.auth.GithubAuthProvider.PROVIDER_ID,
// 		// firebase.auth.EmailAuthProvider.PROVIDER_ID,
// 		// firebase.auth.PhoneAuthProvider.PROVIDER_ID,
// 	],
// 	signInFlow: 'popup',
// 	autoUpgradeAnonymousUsers: true,

// 	// Terms of service url.
// 	tosUrl: 'http://localhost:8080#tos',
// 	callbacks: {
// 		signInFailure(error) {
// 			console.log({error})
// 		},
// 		signInSuccessWithAuthResult: (authResult, redirectUrl) => {
// 			console.log(authResult, redirectUrl)
// 			// Process result. This will not trigger on merge conflicts.
// 			// On success redirect to signInSuccessUrl.
// 			return true
// 		},
// 	},
// }

function createUiConfig(anon) {
	let signinOptions = [
		{
			provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
			requireDisplayName: false,
		},
		firebase.auth.GoogleAuthProvider.PROVIDER_ID,
		firebase.auth.FacebookAuthProvider.PROVIDER_ID,
		firebase.auth.TwitterAuthProvider.PROVIDER_ID,
	]
	let config = {
		// signInSuccessUrl: 'http://localhost:8080#success',
		signInOptions: [firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID],
		signInFlow: 'popup',
		autoUpgradeAnonymousUsers: true,
		// Terms of service url.
		tosUrl: 'http://localhost:8080#tos',
		callbacks: {
			signInFailure(error) {
				console.log({error})
			},
			signInSuccessWithAuthResult: (authResult, redirectUrl) => {
				console.log(authResult, redirectUrl)
				// Process result. This will not trigger on merge conflicts.
				// On success redirect to signInSuccessUrl.
				store.dispatch('setAccount', authResult)
				return true
			},
		},
	}
	if (!anon) {
		config.signInOptions = signinOptions
	}
	return config
}

firebase.initializeApp(config)

let db = firebase.firestore()

db.settings({})

let fbUi = new firebaseui.auth.AuthUI(firebase.auth())

firebase.auth().onAuthStateChanged(account => {
	console.log('State change', account, firebase.auth.UserCredential)
	let acct = account ? JSON.parse(JSON.stringify(account)) : null
	store.dispatch('setAccount', acct)
	loadSessions()
	loadProfile()
})

const saveProfile = payload => {
	let account = store.getters.account
	if (!account.uid) {
		return store.dispatch('setProfile', null)
	}
	db.collection('profiles')
		.doc(account.uid)
		.set({...{account}, ...(payload || {})})
}

const loadProfile = () => {
	let account = store.getters.account
	if (!account.uid) {
		return store.dispatch('setProfile', null)
	}
	let unsubscribe = db
		.collection('profiles')
		.doc(account.uid)
		.onSnapshot(doc => {
			console.log('loadProfile', doc)
			if (!doc.exists) {
				return saveProfile()
			}
			let data = doc.data()
			data.unsubscribe = unsubscribe
			store.dispatch('setProfile', data)
		})
}

const ui = (el, anon) => {
	console.log(fbUi.isPendingRedirect())
	let uiConfig = createUiConfig(anon)
	fbUi.start(el, uiConfig)
}

const loadSession = id => {
	let current = store.getters.session
	if (current && current.id !== id && current.unsubscribe) {
		current.unsubscribe()
	}
	let unsubscribe = db
		.collection('sessions')
		.doc(id)
		.onSnapshot(doc => {
			console.log('loadSession', doc)
			if (!doc.exists) {
				return store.dispatch('setSession', {error: 'Session does not exist'})
			}
			loadResponse(doc.id)
			loadResults(doc.id)
			let data = doc.data()
			data.unsubscribe = unsubscribe
			store.dispatch('setSession', data)
		})
}

const loadLanguage = id => {
	let unsubscribe = db
		.collection('languages')
		.doc(id)
		.onSnapshot(doc => {
			console.log(doc)
			if (!doc.exists) {
				return
			}
			let data = doc.data()
			data.unsubscribe = unsubscribe
			store.dispatch('setText', data)
		})
}

const joinSession = (code, secret) => {
	let account = store.getters.account
	if (!account.uid) {
		return store.dispatch('setSessions', null)
	}
	console.log(code, secret)
	return (
		db
			.collection('sessions')
			.where('code', '==', +code)
			.where('secret', '==', secret)
			// .where(`users.${account.uid}`, '==', null)
			.get()
			.then(querySnapshot => {
				console.log(querySnapshot)
				if (querySnapshot.empty) {
					throw new Error('Session does not exist')
				}
				return querySnapshot.docs[0]
				// querySnapshot.forEach(doc => {
				// 	let current = store.getters.session
				// 	if (current && current.id !== doc.id && current.unsubscribe) {
				// 		current.unsubscribe()
				// 	}
				// 	return doc
				// })
			})
			.then(doc => {
				let now = new Date()
				return db
					.collection('sessions')
					.doc(doc.id)
					.update({
						[`users.${account.uid}`]: now,
						updated: now,
						secret: uuid.v4(),
					})
					.then(() => doc.data())
			})
			.then(resp => {
				console.log('Join', {resp})
			})
			.catch(error => {
				console.log({error})
				return {error}
			})
	)

	// .onSnapshot(doc => {
	// 	console.log('loadSession', doc)
	// 	if (!doc.exists) {
	// 		return store.dispatch('setSession', {error: 'Session does not exist'})
	// 	}
	// 	loadResponse(doc.id)
	// 	loadResults(doc.id)
	// 	let data = doc.data()
	// 	data.unsubscribe = unsubscribe
	// 	store.dispatch('setSession', data)
	// })
}

const loadSessions = () => {
	let account = store.getters.account
	if (!account.uid) {
		return store.dispatch('setSessions', null)
	}
	let unsubscribe = db
		.collection('sessions')
		.where(`users.${account.uid}`, '<', new Date())
		.get()
		.then(querySnapshot => {
			//.onSnapshot(querySnapshot => {
			console.log('SESSIONS 1', querySnapshot)
			if (querySnapshot.empty) {
				return store.dispatch('setSessions', null)
			}
			let sessions = []
			querySnapshot.forEach(doc => {
				console.log('SESSIONS', doc)
				sessions.push(doc.data())
			})
			return store.dispatch('setSessions', sessions)
		})
}

const loadResponse = id => {
	let current = store.getters.response
	if (current && current.id !== id && current.unsubscribe) {
		current.unsubscribe()
	}
	let unsubscribe = db
		.collection('responses')
		.where('sessionId', '==', id)
		.onSnapshot(querySnapshot => {
			if (querySnapshot.empty) {
				return store.dispatch('setResponse', null)
			}
			querySnapshot.forEach(doc => {
				console.log('loadResponse', doc)
				let data = doc.data()
				data.unsubscribe = unsubscribe
				store.dispatch('setResponse', data)
			})
		})
}

const loadResults = id => {
	let current = store.getters.results
	if (current && current.id !== id && current.unsubscribe) {
		current.unsubscribe()
	}
	let unsubscribe = db
		.collection('results')
		.where('sessionId', '==', id)
		.onSnapshot(querySnapshot => {
			if (querySnapshot.empty) {
				return store.dispatch('setResults', null)
			}
			querySnapshot.forEach(doc => {
				console.log('loadResults', doc)
				let data = doc.data()
				data.unsubscribe = unsubscribe
				store.dispatch('setResults', data)
			})
		})
}

const deleteSession = () => {
	let account = store.getters.account
	if (!account.uid) {
		return
	}
	let session = store.getters.session
	let response = store.getters.response
	let results = store.getters.results
	let deleted = {deleted: new Date(), deletedBy: account.uid}
	console.log({deleted})
	let promises = []
	if (session) {
		promises.push(
			db
				.collection('sessions')
				.doc(session.id)
				.update(deleted)
		)
	}
	if (response) {
		promises.push(
			db
				.collection('responses')
				.doc(response.id)
				.update(deleted)
		)
	}
	if (results) {
		promises.push(
			db
				.collection('results')
				.doc(results.id)
				.update(deleted)
		)
	}
	Promise.all(promises)
		.then(resp => {
			console.log('done', {resp})
		})
		.catch(err => {
			console.log({err})
		})
}

loadLanguage('en')

export default ui

// setTimeout(() => {
// 	deleteSession()
// }, 10000)

function logout() {
	firebase.auth().signOut()
	// store.dispatch('setAccount', null)
}

const increment = firebase.firestore.FieldValue.increment

export {ui}
export {db}
export {logout}
export {increment}
export {loadSession}
export {loadResponse}
export {loadResults}
export {deleteSession}
export {joinSession}
